import { Component, OnInit } from '@angular/core';
import { IRegistroVentasItem } from '../interfaces/IRegistroVentaItems';
import { IEdificios } from '../interfaces/Edificios';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ErrorResponse } from '../../applicationinfraestructure/interfaces/error-response';
import { IMarcas } from '../interfaces/Marcas';
import { now } from 'moment';
import { UsersData } from '../../applicationinfraestructure/interfaces/userData';
import { HttpHeaders } from '@angular/common/http';
import { MsalUserService } from '../../applicationinfraestructure/services/msaluser.service';
import { environment } from '../../../environments/environment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { IContratos } from '../interfaces/Contratos';
import { NgxSpinnerService } from 'ngx-spinner';
import { formatDate } from '@angular/common';
import { stringify } from 'querystring';
import { IParameters } from '../interfaces/Parametros';


@Component({
  selector: 'app-registroventas',
  templateUrl: './registroventas.component.html',
  styleUrls: ['./registroventas.component.css']
})
export class RegistroventasComponent implements OnInit {

  Marcas: IRegistroVentasItem[] = [];
  edificios: Array<IEdificios>;
  contratos: IContratos[];
  user: UsersData;
  FechaRegistroVenta: any;
  term: string;
  formRegistro: FormGroup;
  submitted = false;
  CategotiasBaresComidas: string[]
 

  constructor(
    private registroServicios: RegistroVentasService,
    private userData: UsersData,
    private msalService: MsalUserService,
    private spinner: NgxSpinnerService,
    private readonly formBuilder: FormBuilder,) {
      this.user =  userData;
  }
  ngOnInit(): void {
    this.getEdificiosRegistro(environment.edificiosAutorizados, environment.marcasAutorizadas);
    this.construirFromularioRegistro();
    this.getCategorias()
   }

   construirFromularioRegistro() {
    this.formRegistro = this.formBuilder.group({
      edificio: ['', Validators.required]
    });
  }

  get f() { return this.formRegistro.controls; }

   getEdificiosRegistro(edificios: string, marcas: string) {
    this.registroServicios.getEdificiosRegistro(edificios, marcas).subscribe(
      resolve => {
        if (resolve.length != 0) {
          this.edificios = resolve;
        }

      },
      (error: ErrorResponse) => {
        console.error(error);
      }
    );
  }
  clearData()
  {
    this.Marcas = [];
  }
  getContratos() {
    if(this.formRegistro.value.edificio == undefined || this.formRegistro.value.edificio == "") {
      this.submitted = true;
      return;
    }

    this.spinner.show();
    this.registroServicios.getContratos(this.formRegistro.value.edificio, environment.marcasAutorizadas).subscribe(
      contrato => {
        if(contrato.length != 0)
        {
          this.contratos = contrato; 
          this.setMarcasContratos(this.contratos);
          this.submitted = false;
          this.spinner.hide();
      }
      else{
        Swal.fire('No se encontraron registros.');
        this.spinner.hide();
      }
    },
      (error: ErrorResponse) => {
        console.error(error);
        this.spinner.hide();
      }
    );
  }

   setMarcasContratos(contratos: IContratos[]) {
    this.Marcas = <IRegistroVentasItem[]>[];
    for (let i = 0; i < contratos.length; i++) {
        const item = <IRegistroVentasItem>{};
        item.Marca = contratos[i].nombreMarca;
        item.CodMarca = contratos[i].zzcodmarca;
        item.Contrato = contratos[i].recnnrcontrato;
        item.Locales = contratos[i].txtlgobjeto;
        item.Facturas = '';
        item.Productos = '';
        item.Trafico = '';
        item.Ventas = '';
        item.Registrado = true;
        item.FechaRegistro = new Date ;
        item.Usuario = environment.userFullname;
        item.Edificio = contratos[i].codedificio;
        item.Presupuesto = '';
        item.Categoria = contratos[i].industry;
        this.Marcas.push(item);
    }
  }

  error:any={isError:false,errorMessage:''};
  
  compareTwoDates(){
    var fecha = formatDate(this.FechaRegistroVenta, 'yyyy/MM/dd', 'en-US');
    if(new Date(fecha) > new Date()){
       this.error={isError:true,errorMessage: 'La fecha no puede ser mayor al dia actual'};
    }
    else{
     this.error={isError:false,errorMessage: ''};
    }
 }

 getCategorias(){
  this.registroServicios.getParametros("INDUSTRY_IMPOCONSUMO").subscribe((response: IParameters) =>{
    this.CategotiasBaresComidas = response.value.split(";")
  })
 }


}
